import { useEffect, useState } from 'react';

import { useAnalytics } from '../useAnalytics';
import type { ScoreAnalytics } from './models/ScoreTypes';

export function useScoreAnalytics(endDate: Date): {
	scoreAnalytics: ScoreAnalytics | null;
} {
	const { requestScore } = useAnalytics();

	const [scoreAnalytics, setScoreAnalytics] = useState<ScoreAnalytics | null>(null);

	const endTime = endDate.getTime();

	useEffect(() => {
		let active = true;

		const request = () => {
			requestScore(new Date(endTime))
				.then((data) => {
					if (active) setScoreAnalytics(data);
				})
				.catch(() => {
					// Worker restarted mid-request; retry against the new generation.
					if (active) request();
				});
		};

		request();

		return () => {
			active = false;
		};
	}, [requestScore, endTime]);

	return { scoreAnalytics };
}
